import { StyledLoginTitle, StyledLoginSecondaryTitle } from "./styledLoginTitle";

const LoginTitle = () => {
  return (
    <>
      <StyledLoginTitle>Already a Pawshake member?</StyledLoginTitle>
      <StyledLoginSecondaryTitle>Log in below!</StyledLoginSecondaryTitle>
    </>
  );
};

export default LoginTitle;
